// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getEffectiveSupportMaterialsPolicy, } from "@sequentech/ui-core";
import { GET_ELECTION_EVENT } from "../queries/GetElectionEvent";
import { GET_ELECTIONS } from "../queries/GetElections";
/** Attach current dates without changing downloaded objects or signed EML. */
export var capDisplayVotingClose = function (summary, close) {
    if (close === undefined)
        return summary;
    if ((close === null || close === void 0 ? void 0 : close.scheduled_at) && !Number.isFinite(Date.parse(close.scheduled_at))) {
        throw new Error("Invalid voting close metadata");
    }
    return __assign(__assign({}, summary), { election_dates: __assign(__assign({}, summary.election_dates), { authoritative_close: close !== null && close !== void 0 ? close : { scheduled_at: null } }) });
};
var PublicationDownloadError = /** @class */ (function (_super) {
    __extends(PublicationDownloadError, _super);
    function PublicationDownloadError(status) {
        var _this = _super.call(this, "Unable to download published ballot data") || this;
        _this.status = status;
        // Preserve the custom error identity when the production bundle targets ES5.
        Object.setPrototypeOf(_this, PublicationDownloadError.prototype);
        return _this;
    }
    return PublicationDownloadError;
}(Error));
export { PublicationDownloadError };
// Weak client ownership partitions bytes and in-flight requests across authenticated sessions.
var downloads = new WeakMap();
export function fetchPublicationJson(client, url) {
    var _this = this;
    var cache = downloads.get(client);
    if (!cache) {
        cache = new Map();
        downloads.set(client, cache);
    }
    var existing = cache.get(url);
    if (existing)
        return existing;
    var request = (function () { return __awaiter(_this, void 0, void 0, function () {
        var response, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch(url, { credentials: "omit", referrerPolicy: "no-referrer" })];
                case 1:
                    response = _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _c.sent();
                    throw new PublicationDownloadError(0);
                case 3:
                    if (!response.ok)
                        throw new PublicationDownloadError(response.status);
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, response.json()];
                case 5: return [2 /*return*/, (_c.sent())];
                case 6:
                    _b = _c.sent();
                    throw new PublicationDownloadError(response.status);
                case 7: return [2 /*return*/];
            }
        });
    }); })();
    cache.set(url, request);
    void request.catch(function () { return cache === null || cache === void 0 ? void 0 : cache.delete(url); });
    return request;
}
export function mapPublicationFiles(files, load) {
    return __awaiter(this, void 0, Promise, function () {
        var results, next;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    results = new Array(files.length);
                    next = 0;
                    return [4 /*yield*/, Promise.all(Array.from({ length: Math.min(4, files.length) }, function () { return __awaiter(_this, void 0, void 0, function () {
                            var index, _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (!(next < files.length)) return [3 /*break*/, 2];
                                        index = next++;
                                        _a = results;
                                        _b = index;
                                        return [4 /*yield*/, load(files[index])];
                                    case 1:
                                        _a[_b] = _c.sent();
                                        return [3 /*break*/, 0];
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/, results];
            }
        });
    });
}
export function loadPublicationList(client, refs, selectedElectionId) {
    return __awaiter(this, void 0, void 0, function () {
        var files, entries, selectedEvent;
        var _this = this;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    files = selectedElectionId
                        ? refs.files.filter(function (file) { return file.election_id === selectedElectionId; })
                        : refs.files;
                    return [4 /*yield*/, mapPublicationFiles(files, function (file) { return __awaiter(_this, void 0, void 0, function () {
                            var event, election, summary;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, fetchPublicationJson(client, file.urls.event_url)];
                                    case 1:
                                        event = _a.sent();
                                        return [4 /*yield*/, fetchPublicationJson(client, file.urls.election_url)];
                                    case 2:
                                        election = _a.sent();
                                        return [4 /*yield*/, fetchPublicationJson(client, file.urls.summary_url)];
                                    case 3:
                                        summary = _a.sent();
                                        if (event.id !== refs.event_id ||
                                            election.election_event_id !== refs.event_id ||
                                            election.id !== file.election_id ||
                                            summary.id !== file.id) {
                                            throw new Error("Published ballot scope mismatch");
                                        }
                                        return [2 /*return*/, {
                                                event: __assign(__assign({}, event), { status: refs.status }),
                                                election: __assign(__assign({}, election), { status: file.status, num_allowed_revotes: file.num_allowed_revotes, voting_channels: file.voting_channels }),
                                                summary: capDisplayVotingClose(summary, file.signed_close),
                                            }];
                                }
                            });
                        }); })];
                case 1:
                    entries = _d.sent();
                    selectedEvent = (_b = (_a = entries.find(function (entry) { return entry.election.id === selectedElectionId; })) === null || _a === void 0 ? void 0 : _a.event) !== null && _b !== void 0 ? _b : (_c = entries[0]) === null || _c === void 0 ? void 0 : _c.event;
                    return [2 /*return*/, {
                            sequent_backend_election: entries.map(function (entry) { return entry.election; }),
                            sequent_backend_election_event: selectedEvent
                                ? [selectedEvent]
                                : [{ id: refs.event_id, status: refs.status, presentation: null, description: null }],
                            summaries: Object.fromEntries(entries.map(function (entry) { return [entry.election.id, entry.summary]; })),
                        }];
            }
        });
    });
}
export function loadSelectedBallot(client, refs, electionId) {
    return __awaiter(this, void 0, Promise, function () {
        var file, wire, event, style;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    file = refs.files.find(function (file) { return file.election_id === electionId; });
                    if (!file)
                        throw new Error("Election is not authorized or published");
                    return [4 /*yield*/, fetchPublicationJson(client, file.urls.style_url)];
                case 1:
                    wire = _a.sent();
                    return [4 /*yield*/, fetchPublicationJson(client, file.urls.event_url)];
                case 2:
                    event = _a.sent();
                    style = __assign({}, wire);
                    if (typeof wire.ballot_eml_prefix === "string" &&
                        typeof wire.ballot_eml_suffix === "string" &&
                        typeof event.ballot_eml_presentation === "string") {
                        style.ballot_eml =
                            wire.ballot_eml_prefix + event.ballot_eml_presentation + wire.ballot_eml_suffix;
                    }
                    if (style.id !== file.id ||
                        style.election_id !== electionId ||
                        style.election_event_id !== refs.event_id ||
                        typeof style.ballot_eml !== "string") {
                        throw new Error("Published ballot scope mismatch");
                    }
                    return [2 /*return*/, style];
            }
        });
    });
}
// Existing screens still read these GraphQL queries. Populate them from the
// publication snapshot so they do not fetch live presentation or full EML.
export function cachePublicationMetadata(client, data, tenantId, eventId) {
    client.writeQuery({
        query: GET_ELECTION_EVENT,
        variables: { tenantId: tenantId, electionEventId: eventId },
        data: { sequent_backend_election_event: data.sequent_backend_election_event },
    });
    for (var _i = 0, _a = data.sequent_backend_election; _i < _a.length; _i++) {
        var election = _a[_i];
        client.writeQuery({
            query: GET_ELECTIONS,
            variables: { electionIds: [election.id] },
            data: { sequent_backend_election: [election] },
        });
    }
    client.writeQuery({
        query: GET_ELECTIONS,
        variables: { electionIds: data.sequent_backend_election.map(function (election) { return election.id; }) },
        data: { sequent_backend_election: data.sequent_backend_election },
    });
}
/** Resolve one published policy for both the chooser gate and acknowledgement screen. */
export var getPublishedSupportMaterialsPolicy = function (ballotPresentation, eventPresentation) { var _a; return getEffectiveSupportMaterialsPolicy((_a = (ballotPresentation !== null && ballotPresentation !== void 0 ? ballotPresentation : eventPresentation)) === null || _a === void 0 ? void 0 : _a.materials); };
